const createClubsStore = (set) => ({
  clubsList: undefined,
  isLoading: false,

  setClubs: (clubs) =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        clubs: {
          ...state.superadmin.clubs,
          clubsList: clubs,
        },
      },
    })),

  setLoading: (isLoading) =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        clubs: {
          ...state.superadmin.clubs,
          isLoading,
        },
      },
    })),

  // Reset store to initial state
  reset: () =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        clubs: {
          clubsList: [],
          isLoading: false,
        },
      },
    })),
});

export default createClubsStore;
